import { simpleCreateMutation } from '$lib/utils/simpleQueryMutations';
import { ApiMarketplaces } from '@cf/api-v2-types';

export const useMarketplacesReadQuery = () => {
	return simpleCreateMutation(async (data: any) => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');
		const result = await apiMarketplaces.read(data);
		return result;
	});
};

export const useMarketplacesCreateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');

		const result = await apiMarketplaces.create(data);
		return result;
	});
};

export const useMarketplacesUpdateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');

		const result = await apiMarketplaces.update(data);
		return result;
	});
};

export const useMarketplacesDeleteMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');

		const result = await apiMarketplaces.delete(data);
		return result;
	});
};

export const useMarketplacesUrlMutation = () => {
	return simpleCreateMutation<{ urls: string[]; type: string }>(
		async (data: { urls: string[]; type: string }) => {
			const apiMarketplaces = new ApiMarketplaces('/proxy');

			const result = await apiMarketplaces.isValidUrls(data);

			return result;
		}
	);
};

export const useMarketplacesReadAllQuery = () => {
	return simpleCreateMutation(async () => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');
		const result = await apiMarketplaces.all();
		return result;
	});
};

export const useMarketplacesReadByPageQuery = () => {
	return simpleCreateMutation(async (data: any) => {
		const apiMarketplaces = new ApiMarketplaces('/proxy');
		const result = await apiMarketplaces.findByPage(data);
		return result;
	});
};
